"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
const utils_1 = require("../helper/utils");
class FilterNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.FILTER };
    if (props.type !== types_1.NODE_TYPES.FILTER)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    // console.log({ nodeData });
    let deserializeData = {
      expression: "( (c1) )",
      conditions: {
        c1: {
          id: "c1",
          type: types_1.FilterType.PARAM,
          key: "",
          value: "",
          operator: ""
        }
      }
    };
    if (nodeData) {
      let { conditions, expression } = JSON.parse(JSON.stringify(nodeData));
      deserializeData.expression = expression;
      if (conditions && conditions.length > 0) {
        deserializeData.conditions = conditions.reduce((A, e) => {
          //console.log("val", e.value);
          if (e.type === "function") {
            e.value = {
              data: utils_1.addFunctionToSnippet(e.value),
              error: false
            };
          }
          A[e.id] = e;
          return A;
        }, {});
      }
    }
    return deserializeData;
  }
  serialize(uiData) {
    let serializedConditions = [];
    let { conditions, expression } = uiData;
    let index = 1;
    for (let key in conditions) {
      let val = JSON.parse(JSON.stringify(conditions[key]));
      if (val.type === "function") {
        val.value = utils_1.removeFunctionFromSnippet(val.value.data);
      }
      let id = "c" + index;
      val.id = id;
      expression = expression.replace(`(${key})`, `(${id})`);
      index = index + 1;
      serializedConditions.push(val);
    }
    // console.log({ serializedConditions });
    return { conditions: serializedConditions, expression };
  }
  getAttachedApis(selectedResource) {
    return this.getAttachedApisFromParent(selectedResource);
  }
  /**
   *  return extra resources which are path resources
   *  e.g for resource node with addons resources are
   *  resourceNodeId-Instances, resourceNodeId-Instances-addons-Volumes, resourceNodeId-Instances-addOns-SecurityGroups
   *  returns filterNodeId-Instances-addons-Volumes, filterNodeId-Instances-addOns-SecurityGroups
   *
   */
  async getAvailableResourcesForAllPaths() {
    let availableResources = [];
    const selectedResource = this.getSelectedResource();
    if (!selectedResource || !selectedResource.nodeRef) return [];
    let options = await selectedResource.nodeRef.getAvailableResources();
    options = options.filter(x =>
      utils_1.selectedResourceNotEquals(x, selectedResource)
    );
    for (let option of options) {
      let postFix = option.label.substring(option.label.indexOf(".") + 1);
      let label = [this.getNodeName(), postFix].join(".");
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: option.path,
        label,
        context: option.context
      });
    }
    return availableResources;
  }
  async getAvailableResources() {
    let selectedResource = this.getSelectedResource();
    let availableResources = [];
    if (!selectedResource) return [];
    let splitted = selectedResource.label.split(".");
    let label = [this.getNodeName(), splitted[splitted.length - 1]].join(".");
    if (!selectedResource.path) {
      let avRes = await this.getAvailableResourcesForAllPaths();
      availableResources = availableResources.concat(avRes);
    }
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label,
      context: selectedResource.context
    });
    return availableResources;
  }
  /**
   * get output keys for given resource(optional) from its own selected resource
   */
  async getOutputKeys(params) {
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    let { nodeRef } = selectedResource;
    if (!nodeRef) return [];
    return nodeRef.getOutputKeys(params);
  }
  validate() {
    return new validations_1.FilterNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.FilterNode = FilterNode;
//# sourceMappingURL=FilterNode.js.map
